import { Button, Dialog, DialogContent, DialogTitle } from "@mui/material";
import { useEffect, useState } from "react";
import { globalError } from "src/utils/globalError";

interface ErrorPayload {
	title: string;
	message: string;
}

export default function ErrorDialog() {
	const [open, setOpen] = useState(false);
	const [payload, setPayload] = useState<ErrorPayload>({
		title: "",
		message: "",
	});

	useEffect(() => {
		globalError.subscribe(({ title, message }: ErrorPayload) => {
			setPayload({ title, message });
			setOpen(true);
		});
	}, []);

	return (
		<Dialog open={open} onClose={() => setOpen(false)} maxWidth="xs" fullWidth>
			<DialogTitle>{payload.title}</DialogTitle>
			<DialogContent>
				<p>{payload.message ?? "Something went wrong."}</p>
				<div className="mt-4 text-right">
					<Button onClick={() => setOpen(false)} variant="contained">
						OK
					</Button>
				</div>
			</DialogContent>
		</Dialog>
	);
}
